<header
  class="nav-bar border-b border-slate-100 h-14 bg-white w-full flex items-center shadow-[0_1px_2px_0_rgba(0,0,0,0.02)]">
  <nav class="w-full flex items-center justify-between px-4">
    <!-- Left Section: Logo only -->
    <a routerLink="/apps" class="flex items-center shrink-0">
      <img class="h-[40px] w-auto object-contain  pr-3 mr-2 hover:opacity-80 transition-opacity"
        src="/assets/img/logo-new.svg" alt="Logo" />
      <!-- <span class="mx-2 text-md font-medium text-indigo-950">
        @if (moduleName != 'Trip And Expense') {
        <span>Emerge - {{ moduleName }}</span>
        } @else {
        <span>{{ moduleName }}</span>
        }
      </span> -->
    </a>

    <!-- Mobile Hamburger Menu Button -->
    <div class="flex lg:hidden ml-4">
      @if (shouldShowMenuButton()) {
      <!-- <button type="button" id="menuButton"
        class="-m-2.5 inline-flex items-center justify-center rounded-xl p-2 text-slate-700 hover:bg-slate-100 transition-colors focus:outline-none"
        aria-haspopup="dialog" aria-expanded="false" aria-controls="offcanvas-menu" data-hs-overlay="#offcanvas-menu">
        <span class="sr-only">Open main menu</span>
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor"
          aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
        </svg>
      </button> -->
      }
    </div>

    <!-- Right Section: Actions & Profile -->
    <div class="flex items-center gap-3">

      <!-- Apps Dropdown -->
      <div class="relative inline-flex">
        @if(isAppsButtonVisible){
          <button #appsTrigger type="button" (click)="toggleDropdown($event, 'apps')"
            class="flex items-center gap-2 px-3 py-1.5 rounded-full border border-transparent transition-all duration-200 focus:!outline-none
          focus:ring-0 !outline-none hover:bg-slate-100"
            id="apps" aria-haspopup="menu" [attr.aria-expanded]="isAppsOpen" aria-label="Dropdown">
            <svg class="w-5 h-5 text-indigo-950" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="3" width="7" height="7" rx="1.5" stroke-linejoin="round"></rect>
              <rect x="14" y="3" width="7" height="7" rx="1.5" stroke-linejoin="round"></rect>
              <rect x="14" y="14" width="7" height="7" rx="1.5" stroke-linejoin="round"></rect>
              <rect x="3" y="14" width="7" height="7" rx="1.5" stroke-linejoin="round"></rect>
            </svg>
            <span class="text-xs font-medium text-indigo-950 tracking-wide">Apps</span>
          </button>
        }

        <!-- Apps Dropdown Card (Popup) -->
        <ng-template #appsMenuTemplate>
          <div @slideOverlay
            [class.overlay-dropdown-closing]="isAppsClosing"
            class="z-40 w-[400px] max-w-[72vw] bg-white border border-[#e4e6ec] rounded-xl shadow-lg p-3 transition-all duration-200"
            (click)="$event.stopPropagation()" id="apps_menu" role="menu" aria-orientation="vertical"
            aria-labelledby="apps">
            <!-- Title -->
            <div class="text-[11px] font-semibold tracking-wider text-indigo-950 uppercase mb-2.5">EMERGE APPS</div>

            <!-- Search Input -->
            <div class="relative w-full mb-2">
              <span class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg class="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" stroke-width="2"
                  viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z">
                  </path>
                </svg>
              </span>
              <input type="text" (input)="onSearchApps($event)" [value]="store.searchQuery()"
                class="w-full h-8 pl-8 pr-8 rounded-xl border border-gray-200 text-xs text-indigo-950 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-950/20"
                placeholder="Search apps...">
              @if (store.searchQuery()) {
              <button type="button" (click)="clearAppsSearch($event)"
                class="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400 hover:text-[#FB4F14] transition-colors"
                aria-label="Clear search">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M18 6 6 18"></path>
                  <path stroke-linecap="round" stroke-linejoin="round" d="m6 6 12 12"></path>
                </svg>
              </button>
              }
            </div>

            <!-- Apps Grid -->
            <div class="grid grid-cols-2 gap-1.5 max-[480px]:grid-cols-1">
              <!-- VMS App Button -->

              @if (canAccessVMS() && matchesSearch('VMS', 'Vendor management system')) {
              <button (click)="toVms()" [ngClass]="{'bg-slate-100 !border-[#080845]': moduleName === 'VMS'}"
                class="flex items-center gap-2 p-2 rounded-xl border transition-colors border-transparent group text-left w-full focus:outline-none hover:bg-slate-100 hover:border-[#080845]">
                <div
                  class="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-br from-sky-400 to-blue-500 text-white shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-factory w-[18px] h-[18px]">
                    <path d="M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z">
                    </path>
                    <path d="M17 18h1"></path>
                    <path d="M12 18h1"></path>
                    <path d="M7 18h1"></path>
                  </svg>
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-[11px] font-semibold text-indigo-950 tracking-wide truncate">VMS</span>
                  <span class="block text-[10.5px] text-[#6b6e7d] truncate">Visitors, Passes &amp; check-ins</span>
                </div>
              </button>
              }

              <!-- Admin App Button -->
              @if (canAccessAdmin() && matchesSearch('Admin', 'Users, roles & access')) {
              <button (click)="toAdmin()" [ngClass]="{'bg-slate-100 !border-[#080845]': moduleName === 'Admin'}"
                class="flex items-center gap-2 p-2 rounded-xl border transition-colors border-transparent group text-left w-full focus:outline-none hover:bg-slate-100 hover:!border-[#080845]">
                <div
                  class="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-br from-amber-400 to-yellow-500 text-white shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-users w-[18px] h-[18px]">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-[11px] font-semibold text-indigo-950 tracking-wide truncate">Admin</span>
                  <span class="block text-[10.5px] text-[#6b6e7d] truncate">Settings, Masters &amp; configuration</span>
                </div>
              </button>
              }

              <!-- Grievance App Button -->
              @if ((isAdminLogin() || isGrievanceModuleAccess() || isRaiseGrievanceAccess()) &&
              matchesSearch('Grievance', 'Raise & track grievances')) {
              <button (click)="toGrievance()" [ngClass]="{'bg-slate-100 !border-[#080845]': moduleName === 'Grievance'}"
                class="flex items-center gap-2 p-2 rounded-xl border transition-colors border-transparent group text-left w-full focus:outline-none hover:bg-slate-100 hover:border-[#080845]">
                <div
                  class="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-br from-rose-400 to-red-500 text-white shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-message-square-warning w-[18px] h-[18px]">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                    <path d="M12 7v2"></path>
                    <path d="M12 13h.01"></path>
                  </svg>
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-[11px] font-semibold text-indigo-950 tracking-wide truncate">Grievance</span>
                  <span class="block text-[10.5px] text-[#6b6e7d] truncate">Complaints, Tracking &amp; resolution</span>
                </div>
              </button>
              }

              <!-- Expense App Button -->
              @if (allowExpenseModule && matchesSearch('Expense', 'Trips, claims & approvals')) {
              <button (click)="toExpense()"
                [ngClass]="{'bg-slate-100 !border-[#080845]': moduleName === 'Trip And Expense'}"
                class="flex items-center gap-2 p-2 rounded-xl border transition-colors border-transparent group text-left w-full focus:outline-none hover:bg-slate-100 hover:border-[#080845]">
                <div
                  class="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-br from-emerald-400 to-green-500 text-white shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-wallet w-[18px] h-[18px]">
                    <path
                      d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1">
                    </path>
                    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4"></path>
                  </svg>
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-[11px] font-semibold text-indigo-950 tracking-wide truncate">Expense</span>
                  <span class="block text-[10.5px] text-[#6b6e7d] truncate">Trips, claims &amp; approvals</span>
                </div>
              </button>
              }

              <!-- Conference Room App Button -->
              @if (canAccessConferenceRoom() && matchesSearch('Conference Room', 'Bookings, approvals & reports')) {
              <button (click)="toConferenceRoom()"
                [ngClass]="{'bg-slate-100 !border-[#080845]': moduleName === 'Conference Room'}"
                class="flex items-center gap-2 p-2 rounded-xl border transition-colors border-transparent group text-left w-full focus:outline-none hover:bg-slate-100 hover:border-[#080845]">
                <div
                  class="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-br from-orange-400 to-amber-500 text-white shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-building-2 w-[18px] h-[18px]">
                    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18"></path>
                    <path d="M6 12H4a2 2 0 0 0-2 2v8h20v-8a2 2 0 0 0-2-2h-2"></path>
                    <path d="M10 6h4"></path>
                    <path d="M10 10h4"></path>
                    <path d="M10 14h4"></path>
                    <path d="M10 18h4"></path>
                  </svg>
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-[11px] font-semibold text-indigo-950 tracking-wide truncate">Conference Room</span>
                  <span class="block text-[10.5px] text-[#6b6e7d] truncate">Manage conferences and meetings</span>
                </div>
              </button>
              }
              <!-- Conference Room App Button End -->

              <!-- Approval Notes App Button -->
              @if (canAccessApprovalNotes() && matchesSearch('Approval Notes', 'View & manage approval notes')) {
              <button (click)="toApprovalNotes()" [ngClass]="{'bg-slate-100 !border-[#080845]': moduleName === 'Approval Notes'}"
                class="flex items-center gap-2 p-2 rounded-xl border transition-colors border-transparent group text-left w-full focus:outline-none hover:bg-slate-100 hover:border-[#080845]">
                <div
                  class="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-br from-indigo-400 to-indigo-500 text-white shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-file-text w-[18px] h-[18px]">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <path d="M14 2v6h6"></path>
                    <path d="M16 13H8"></path>
                    <path d="M16 17H8"></path>
                    <path d="M10 9H9"></path>
                  </svg>
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-[11px] font-semibold text-indigo-950 tracking-wide truncate">Approval Notes</span>
                  <span class="block text-[10.5px] text-[#6b6e7d] truncate">View & manage approval notes</span>
                </div>
              </button>
              }

              <!-- Documents App Button -->
              @if (canAccessDocuments() && matchesSearch('Documents', 'Upload, organize and share files')) {
              <button (click)="toDocuments()" [ngClass]="{'bg-slate-100 !border-[#080845]': moduleName === 'Documents'}"
                class="flex items-center gap-2 p-2 rounded-xl border transition-colors border-transparent group text-left w-full focus:outline-none hover:bg-slate-100 hover:border-[#080845]">
                <div
                  class="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-br from-violet-400 to-indigo-500 text-white shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-file-text w-[18px] h-[18px]">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <path d="M14 2v6h6"></path>
                    <path d="M8 13h8"></path>
                    <path d="M8 17h8"></path>
                  </svg>
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-[11px] font-semibold text-indigo-950 tracking-wide truncate">Documents</span>
                  <span class="block text-[10.5px] text-[#6b6e7d] truncate">Upload, organize and share files</span>
                </div>
              </button>
              }

              <!-- AI Buddy App Button -->
              <!-- @if (isAdminLogin() && matchesSearch('AI Buddy', 'AI Assistant')) { -->
              @if (isAiBuddyEnabled() && matchesSearch('AI Buddy', 'AI Assistant')) {
              <button (click)="toAiBuddy()" [ngClass]="{'bg-slate-100 !border-[#080845]': moduleName === 'AI Buddy'}"
                class="flex items-center gap-2 p-2 rounded-xl border transition-colors border-transparent group text-left w-full focus:outline-none hover:bg-slate-100 hover:border-[#080845]">
                <div
                  class="w-9 h-9 rounded-xl flex items-center justify-center bg-gradient-to-br from-pink-500 to-pink-300 text-white shrink-0">
                  <i class="fa-solid fa-robot text-white h-6 w-6 flex items-center justify-center"></i>
                </div>
                <div class="flex flex-col min-w-0">
                  <span class="text-[11px] font-semibold text-indigo-950 tracking-wide truncate">AI Buddy</span>
                  <span class="block text-[10.5px] text-[#6b6e7d] truncate">Listen whenever you need</span>
                </div>
              </button>
              }
            </div>
          </div>
        </ng-template>
      </div>

      <!-- User Profile Dropdown -->
      <div [class.border-transparent]="!isAppsButtonVisible" class="relative inline-flex border-l border-[#e4e6ec] h-10">
        <button id="hs-dropdown-custom-trigger" type="button" (click)="toggleDropdown($event, 'profile')"
          class="flex items-center gap-3 px-3 py-1.5 rounded-full border border-transparent transition-all duration-200 focus:!outline-none
          focus:ring-0 !outline-none text-left hover:bg-slate-100"
          aria-haspopup="menu" [attr.aria-expanded]="isProfileOpen" aria-label="Dropdown">
          <!-- Avatar Initial Circle -->
          <div
            class="w-7 h-7 rounded-full flex items-center justify-center bg-indigo-950 text-white text-[12px] font-medium tracking-wider uppercase shrink-0 shadow-inner">
            {{ firstname ? firstname.substring(0, 2).toUpperCase() : 'AT' }}
          </div>
          <!-- User Profile Label (Hidden on mobile) -->
          <div class="hidden md:flex flex-col text-left">
            <span class="text-[12px] font-semibold text-indigo-950 leading-tight tracking-wide truncate max-w-[160px]">{{
              capitalizeFirstLetter(firstname) + ' ' + capitalizeFirstLetter(lastname) }}</span>
          </div>
          <!-- Chevron Icon -->
          <svg class="w-4 h-4 text-slate-400 transition-transform duration-200 shrink-0"
            [class.rotate-180]="isProfileOpen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m6 9 6 6 6-6" />
          </svg>
        </button>

        <!-- User Profile Dropdown Card (Popup) -->
        @if (isProfileOpen) {
        <div id="profile_menu" @slideOverlay
          class="hs-dropdown-menu z-50 bg-white border border-[#e4e6ec] rounded-[20px] w-64 mt-2 transition-all duration-200 overflow-hidden shadow-md"
          (click)="$event.stopPropagation()" role="menu" aria-orientation="vertical"
          aria-labelledby="hs-dropdown-custom-trigger">
         

          <!-- Dropdown Menu Items -->
          <div class="p-1">
            <!-- My Account Item (triggers toAccount()) -->
            <button (click)="toAccount()" type="button"
              class="w-full flex items-center gap-2 py-2 px-4 rounded-xl text-sm text-slate-700 font-medium transition-all duration-150 focus:outline-none text-left group hover:bg-gradient-to-r hover:from-[#ff5a36] hover:to-[#ff6f48] hover:text-white"
              role="menuitem">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-circle-user w-4 h-4 text-slate-700 group-hover:text-white transition-colors">
                <circle cx="12" cy="12" r="10"></circle>
                <circle cx="12" cy="10" r="3"></circle>
                <path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"></path>
              </svg>
              My Account
            </button>

            <!-- Separator -->
            <!-- <div class="border-t border-slate-100 my-1"></div> -->

            <!-- Sign out Item (triggers toLogout()) -->
            <button (click)="toLogout()" type="button"
              class="w-full flex items-center gap-2 py-2 px-4 rounded-xl text-sm text-red-600 font-medium transition-all duration-150 transition-colors focus:outline-none text-left group hover:bg-gradient-to-r hover:from-[#ff5a36] hover:to-[#ff6f48] hover:text-white"
              role="menuitem">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-log-out w-4 h-4">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" x2="9" y1="12" y2="12"></line>
              </svg>
              Sign out
            </button>
          </div>
        </div>
        }
      </div>

    </div>

    <!-- offcanvas menu -->
    <div id="offcanvas-menu"
      class="offcanvas lg:hidden inset-0 p-3 hs-overlay hs-overlay-open:translate-x-0 hidden -translate-x-full fixed top-0 start-0 transition-all duration-300 transform h-full max-w-xs w-full z-[80] bg-white border-e dark:bg-neutral-800 dark:border-neutral-700">
      <div class="flex items-center justify-between">
        <a class="lg:w-64 w-50 pl-3 bg-white shrink-0 flex items-center">
          <img class="w-auto h-6 sm:h-10" src="/assets/img/logo-new.svg" alt="Logo" />
          <span class="mx-2 text-2xl font-semibold text-indigo-950"> {{moduleName}} </span>
        </a>
        <button type="button" id="closeButton" class="-m-2.5 rounded-md p-2.5 text-gray-700" aria-label="Close"
          data-hs-overlay="#offcanvas-menu">
          <span class="sr-only">Close menu</span>
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
      <div class="mt-6 flow-root">
        <div class="-my-6 divide-y divide-gray-500/10">
          <div class="space-y-2 py-6">
            <nav>
              <ng-container *ngFor="let item of sidebarMenu">
                @if (!item.hasSubRoute) {
                <a class="flex items-center px-4 py-2 mt-2 text-gray-600 transition-colors duration-300 transform rounded-md hover:bg-gray-100 hover:text-blue-500"
                  [routerLink]="item.route" routerLinkActive="bg-gray-100 !text-blue-500"
                  (click)="navigateTo(item.route)">
                  <span class="icon w-6 h-6" [innerHTML]="safeIcon(item.icon)"></span>
                  <span class="mx-4 font-medium">{{ item.title }}</span>
                </a>
                }

                @if (item.hasSubRoute) {
                <div class="mt-2">
                  <a class="flex items-center px-4 py-2 text-gray-600 transition-colors duration-300 transform rounded-md hover:bg-gray-100 hover:text-blue-500"
                    (click)="toggleSubRoute(item)">
                    <span class="icon w-6 h-6" [innerHTML]="safeIcon(item.icon)"></span>
                    <span class="mx-4 font-medium">{{ item.title }}</span>
                    <svg class="w-5 h-5 ml-auto transition-transform" [class.rotate-180]="item.showSubRoute"
                      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </a>

                  @if (item.showSubRoute) {
                  <div class="ml-8">
                    <a *ngFor="let subMenu of item.subMenu"
                      class="flex items-center px-4 py-2 mt-2 text-gray-600 transition-colors duration-300 transform rounded-md text-sm hover:bg-gray-100 hover:text-blue-500"
                      [routerLink]="subMenu.route" (click)="navigateTo(subMenu.route)"
                      routerLinkActive="bg-gray-100 !text-blue-500">
                      @if (subMenu.icon) {
                      <span class="icon w-4 h-4" [innerHTML]="safeIcon(subMenu.icon)"></span>
                      }
                      <span class="mx-2 font-medium">{{ subMenu.title }}</span>
                    </a>
                  </div>
                  }
                </div>
                }
              </ng-container>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>
